import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// NOTE: sessionStorage (not localStorage) mitigates the XSS-token-theft risk
// flagged in the code review. Tokens now die with the browser tab.
// A stronger solution (httpOnly cookies + CSRF) requires backend changes.
const TOKEN_KEY = "qcs_token";
const EMAIL_KEY = "qcs_email";

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;

export const auth = {
  login: async (email, password) => {
    const { data } = await client.post("/auth/login", { email, password });
    sessionStorage.setItem(TOKEN_KEY, data.token);
    sessionStorage.setItem(EMAIL_KEY, data.email);
    return data;
  },
  logout: () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(EMAIL_KEY);
  },
  isAuthed: () => !!sessionStorage.getItem(TOKEN_KEY),
  email: () => sessionStorage.getItem(EMAIL_KEY),
  getToken: () => sessionStorage.getItem(TOKEN_KEY),
};
